import React, { useState } from 'react';
import { FiX, FiSearch } from 'react-icons/fi';
import { MdMenuBook } from 'react-icons/md';
import { t, useLanguage } from '../useTranslations';
import '../styles/Glossary.css';

const GLOSSARY_TERMS = [
  'aml', 'bwra', 'cdd', 'edd', 'fatf', 'grossRisk', 'kri', 'kyc', 'pep',
  'periodicReporting', 'residualRisk', 'riskAppetite', 'riskIndex', 'riskModel',
  'riskScore', 'sdd', 'str', 'transactionMonitoring',
];

const Glossary = ({ onClose }) => {
  useLanguage();
  const [search, setSearch] = useState('');

  const filtered = GLOSSARY_TERMS.filter(key => {
    const title = t(`glossary.${key}.title`).toLowerCase();
    const def = t(`glossary.${key}.definition`).toLowerCase();
    const q = search.toLowerCase();
    return title.includes(q) || def.includes(q);
  });

  return (
    <div className="glossary-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label={t('glossary.title')}>
      <div className="glossary-modal" onClick={e => e.stopPropagation()}>
        <div className="glossary-header">
          <div className="glossary-header-title">
            <MdMenuBook className="glossary-header-icon" size={24} />
            <h2>{t('glossary.title')}</h2>
          </div>
          <button className="glossary-close" onClick={onClose} aria-label={t('common.close')}>
            <FiX size={20} />
          </button>
        </div>
        <p className="glossary-subtitle">{t('glossary.subtitle')}</p>

        <div className="glossary-search">
          <FiSearch className="glossary-search-icon" />
          <input
            type="text"
            className="glossary-search-input"
            placeholder={t('glossary.searchPlaceholder')}
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoFocus
          />
        </div>

        <div className="glossary-list">
          {filtered.length === 0 ? (
            <p className="glossary-empty">{t('glossary.noResults')}</p>
          ) : (
            filtered.map(key => (
              <div key={key} className="glossary-item">
                <div className="glossary-item-title">{t(`glossary.${key}.title`)}</div>
                <div className="glossary-item-def">{t(`glossary.${key}.definition`)}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Glossary;
